import type { SortDirection } from '@tanstack/table-core';

export type SortingArrowsProps = {
  sorting: SortDirection | false;
};

export function SortingArrows({ sorting }: SortingArrowsProps) {
  return (
    <svg
      width="9"
      height="10"
      className="kunde:size-3 text-neutral-60"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      viewBox="0 0 9 10"
    >
      <path
        d="M8 4H0l4-4 4 4Z"
        className={
          sorting === 'asc' ? 'kunde:text-blue-60 text-blue-100' : undefined
        }
        fill="currentColor"
      />
      <path
        d="M8 6H0l4 4 4-4Z"
        className={
          sorting === 'desc' ? 'kunde:text-blue-60 text-blue-100' : undefined
        }
        fill="currentColor"
      />
    </svg>
  );
}

export default SortingArrows;
